import React from "react";

const CustomTabs = ({ tabs, subTabs, mainTab, setMainTab, childTab, setChildTab }) => {
  return (
    <div className="bg-gray-800 rounded-md w-full">
      {/* Main Tabs */}
      <div className="flex rounded-ss rounded-se overflow-hidden">
        {tabs.map((tab) => (
          <button
            className={`flex-1 text-center text-sm border-b py-1.5 ${
              mainTab === tab.value ? "bg-white/15 border-primary text-white" : "bg-white/5 border-transparent text-white/40"
            } transition-colors`}
            onClick={() => setMainTab(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Sub Tabs */}
      {subTabs && (
        <div className="flex ">
          {subTabs.map((tab) => (
            <button
              className={`flex-1 text-center text-sm border-b py-1.5 ${
                childTab === tab.value ? "bg-white/15 border-primary text-white" : "bg-white/5 border-white/10 text-white"
              } transition-colors`}
              onClick={() => setChildTab(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomTabs;
